// @ts-nocheck
// https://github.com/embiem/react-canvas-draw/issues/62

import { IPlatMap } from '../models';

/**
 * takes the canvas ref and combines the drawing and background image into a new flat image to save
 * @param canvasRef the ref of the canvas drawing an image
 * @returns
 */
export const combineDrawing = (canvasRef: any, selectedPlatMap?: IPlatMap, uploadImage?: File) => {
  const { canvasWidth, canvasHeight } = canvasRef.current.props;
  const [cursor, drawing, canvasInterface, backgroundImg] = canvasRef.current.canvasContainer.children;
  const canvas = document.createElement('canvas');
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  // composite now
  // set a background color of white
  canvas.getContext('2d').fillStyle = '#fff';
  canvas.getContext('2d').fillRect(0, 0, canvasWidth, canvasHeight);
  canvas.getContext('2d').drawImage(backgroundImg, 0, 0);
  canvas.getContext('2d').globalAlpha = 1.0;
  canvas.getContext('2d').drawImage(drawing, 0, 0);
  canvas.getContext('2d').drawImage(cursor, 0, 0);
  canvas.getContext('2d').drawImage(canvasInterface, 0, 0);

  const dataUri = canvas.toDataURL(
    (selectedPlatMap && selectedPlatMap.extension && selectedPlatMap.extension.includes('png')) || (uploadImage && uploadImage.type === 'image/png') ? 'image/png' : 'image/jpeg',
    1.0
  );
  const data = dataUri.split(',')[1];
  const mimeType = dataUri.split(';')[0].slice(5);
  const bytes = window.atob(data);
  const buf = new ArrayBuffer(bytes.length);
  const arr = new Uint8Array(buf);

  for (let i = 0; i < bytes.length; i++) {
    arr[i] = bytes.charCodeAt(i);
  }
  const blob = new Blob([arr], { type: mimeType });
  return { blob, dataUri };
};

/**
 * Original from: https://stackoverflow.com/questions/21961839/simulation-background-size-cover-in-canvas
 * Original By Ken Fyrstenberg Nilsen
 *
 * Note: img must be fully loaded or have correct width & height set.
 */
export const drawImageProp = ({ ctx, img, x, y, w, h, offsetX, offsetY } = {}) => {
  // Defaults
  if (typeof x !== 'number') x = 0;
  if (typeof y !== 'number') y = 0;
  if (typeof w !== 'number') w = ctx.canvas.width;
  if (typeof h !== 'number') h = ctx.canvas.height;
  if (typeof offsetX !== 'number') offsetX = 0.5;
  if (typeof offsetY !== 'number') offsetY = 0.5;

  // keep bounds [0.0, 1.0]
  if (offsetX < 0) offsetX = 0;
  if (offsetY < 0) offsetY = 0;
  if (offsetX > 1) offsetX = 1;
  if (offsetY > 1) offsetY = 1;

  var iw = img.width,
    ih = img.height,
    r = Math.min(w / iw, h / ih),
    nw = iw * r, // new prop. width
    nh = ih * r, // new prop. height
    cx,
    cy,
    cw,
    ch,
    ar = 1;

  // decide which gap to fill
  if (nw < w) ar = w / nw;
  if (Math.abs(ar - 1) < 1e-14 && nh < h) ar = h / nh; // updated
  nw *= ar;
  nh *= ar;

  // calc source rectangle
  cw = iw / (nw / w);
  ch = ih / (nh / h);

  cx = (iw - cw) * offsetX;
  cy = (ih - ch) * offsetY;

  // make sure source rectangle is valid
  if (cx < 0) cx = 0;
  if (cy < 0) cy = 0;
  if (cw > iw) cw = iw;
  if (ch > ih) ch = ih;

  // fill image in dest. rectangle
  ctx.drawImage(img, cx, cy, cw, ch, x, y, w, h);
};
